export default {
    startPage: {
        title: 'Vue 学习'
    },
    menu: {
        Documents: '运动档案',
        Setting: '系统设置',
        Applications: "测试系统",
        Report: "分析报告",
        AthleteDocuments: "运动员",
        SportProject: "运动项目",
        Options: "基础设置",
        Permission: "权限管理",
        StandardData: "标准值管理",
        MuscleStrengthStandard: '便携肌力参考值',
        //SportsPerformanceStandardData:'运动功能表现参考值',
        UserManagement: "人员管理",
        Subject: "运动员详情",
        Record: "个人记录",
        Result: "测试结果",
        Actions: "动作数据",
        SportsPerformanceStandardData: '运动功能表现系统',
        MuscleStrengthStandardData: '便携肌力测试系统'
    },
    userMenu: {
        confirmExit: '退出登录',
        confirmMsg: '确认要退出登录吗?',
        DarkMode: '深色模式',
        Modify: '修改资料',
        Account: '账号',
        UserName: '用户名',
    },
    options: {
        Title: '偏好设置',
        Language: '语言',
        ModifyNotice: '修改成功',
        ModifyNotice2: '修改失败',
        SystemSettings: '基础设置',
        AccountSetting: '账号设置',
        Account: '账号',
        OrganizationInfo: '组织信息',
        CompanyName: '公司名称:',
        CompanyCode: '公司代码:',
        CustomLogo: '自定义Logo',
        Name: '姓名',
        Preview: '预览',
        UploadPictures: '点击上传图片',
        Notice1: '图片最佳尺寸高度48px，宽度200px以内，小于1Mb，png或jpg格式',
        ModifyPassword: '重置/修改密码',
        confirmExit: '退出登录',
        ModifyName: '修改姓名',
        notice2: '姓名修改成功',
        notice3: '请输入姓名',
        Lable: {
            Multilingual: '多语言',
            Logo: '自定义Logo',
        }
    },
    login: {
        Label: {
            UserName: '账号',
            Password: '密码',
            Login: '登录',
            Reset: '重置',
            Title: '请登录',
            Title2: '注册',
            Forget: '忘记密码?',
            Remember: '记住密码',
            Register: '去注册>>',
            ToLogin: '已有账号，去登录>>',
            Captche: '获取验证码',
            Retry: '重新获取',
            Agree: '同意《用户协议》',
            UserNamePlaceholde: '请输入用户名',
            PasswordPlaceholde: '请输入密码',
            CompanyCodePlaceholder: '公司代码',
            MailBoxPlaceHolder: '请输入邮箱',
            CaptchaPlaceholder: '邮箱验证码',
        },
        Message: {
            PasswordLength: '密码长度在8-16个字符之间',
            CaptchaSuccess: '发送成功',
            Agree: '请阅读并勾选《用户协议》',
            AccountEmpty: '请正确填写邮箱',
            Registered: '注册成功',
            loginFaild: "登录失败",
            Captcha: '验证码长度不足',
            CaptchaLenthL: '请输入完整的验证码',
            CompanyCodeLength: '请输入正确的的公司代码',
        }
    },
    forget: {
        Label: {
            Title: '找回密码',
            GoToLogin: '去登陆>>',
            Captche: '获取验证码',
            Reset: '重置密码',
            Retry: '重新获取',
            Contact: '如该页面无法解决请联系客服',
            AccountPlaceholder: '请输入登录的邮箱',
            CaptchaPlaceholder: '邮箱验证码',
            PasswordPlaceholder: '新密码',
            ModifyPassword: '修改密码',
        },
        Message: {
            CaptchaSuccess: '发送成功',
            ResetSuccess: '重置密码成功',
            AccountEmpty: '请正确填写邮箱',
        }
    },
    global: {
        HomePage: '首页',
        Loading: '加载中',
        CopySuccess: '复制成功',
        CopyFailed: '复制失败',
        Refresh: '刷新',
        Add: '添加',
        Create: '新建',
        Modify: '修改',
        Confirm: '确认',
        Cancel: '取消',
        Save: '保存',
        View: "查看",
        Edit: "编辑",
        Delete: "删除",
        Finish: "完成",
        LastWeek: "最近一周",
        LastMonth: "最近一个月",
        Last3Month: "最近三个月",
        StartDate: "开始日期",
        EndDate: "截至日期",
        TestProject: "测试项目",
        SportProject: "运动项目",
        None: "不限",
        Gender: "性别",
        RequestFailed: '发送请求失败!',
        ResponseFailed: '请求返回失败!',
        LoadSuccess: '下载成功',
        LoadFailed: '下载失败',
        EditRelation: '编辑运动关系',
        EditSubject: '编辑运动员信息',
        EditProject: '编辑运动项目',
        Import: '导入',
        Export: '导出',
        NoneData: '暂无数据',
        NoneRank: '暂无排名',
        SaveSuccess: "保存成功",
        Checked: '选中',
        Close: '关闭'
    },
    Permission: {
        Label: {
            Title: "权限管理",
            Enable: "启用",
            Description: '描述',
            ExpireDate: '到期时间',
            CreateGroup: "创建分组",
            GroupRole: "角色类型",
            GroupName: "角色名称",
            SelectRoleType: "选择角色类型",
        },
        Message: {
            GetGroupsFailed: "获取分组失败",
            GetApplicationListFailed: '获取应用列表失败',
            ChangeUnsaved: "有未保存的修改,确认要离开吗?",
            ComfirmToDelete: "确认要删除这个组吗?",
            DeleteSuccess: '删除成功',
        }
    },
    Documents: {
        Lable: {
            ViewPersonDocument: '查看个人档案',
            InvationInfo: '邀请用户注册',
            DeleteInvation: '删除邀请',
            ViewHistoryRecords: '查看历史记录',
            ViewDetailRecords: '查看记录详情',
            TestDetialExport: '记录详情导出',
            ViewActionDetail: '查看动作详情',
            ActionDataExport: '动作数据导出',
        },
        HomePage: '首页',
        Reinvite: '重新邀请',
        SportDocuments: '运动档案',
        RegisterSubject: {
            Title: '邀请您完善资料',
            Save: '提交资料',
            From: '来自',
            Invitation: '的邀请',
            PlaseEnter: '请输入',
        },
        Athletes: {
            TotalCount: '当前共',
            TotalProjects: '个项目',
            DeleteNotice: '确定要删除处于信息填写邀请中的运动员吗？',
            ProjectNameSearch: '支持运动项目名称搜索',
            selectDate: '选择日期',
            CreateTime: '创建时间',
            ClickShow: '点击展开',
            ClickPutaway: '点击收起',
            FormarErrorNotice: '(注意:至多可保留到小数点后一位)',
            EmailNoticeLogin: '邮箱(可用于登录)',
            LoginEmail: '可用于登录',
            Athletes: '运动员',
            MultipleSelection: '多选',
            true: '多选',
            false: '完成',
            AddDocuments: '添加档案',
            TestSystem: '测试系统单选',
            Nodata: '无数据',
            SportFunction: '运动功能表现测试系统',
            DigitalRunway: '数字化跑道数据采集分析软件',
            MuscleStrength: '肌肉力量测试系统',
            GolfTechnique: '高尔夫技术诊断',
            Screening: '筛选',
            GenderLimit: '性别不限',
            SystemLimit: '系统不限',
            TestProject: '测试项目',
            Photo: '照片',
            NextPage: '下一页',
            PreviousPage: '上一页',
            Age: '年龄',
            View: '查看',
            EditingData: '编辑资料',
            HistoricalRecord: '历史记录',
            SkipPages: '跳页',
            AddTestProject: '+添加到测试项目',
            AssociationSportProject: '+关联运动项目',
            DeldeteDocument: '删除档案',
            Complete: '完成',
            SearchNotice: '支持姓名搜索',
            CreateSubject: '新增档案',
            ModifySubject: '修改档案',
            AddRelationSuccessNotice: '添加关联成功',
            AddRelationFailNotice: '添加关联失败',
            AddRelationNotice: '请选择要关联的项目',
            BaseInfo: '基本信息',
            InviteUsersRegister: '邀请用户注册',
            Save: '保存',
            Total: '共',
            Projects: '个项目当前全部',
            Picture: '照片',
            PhotoLimitNotice: '限1M以内照片',
            PhotoLimitNotice2: '请上传照片，大小1M以内',
            Name: '姓名',
            EnterNotice: '请输入运动员姓名',
            Gneder: '性别',
            Birthday: '生日',
            Height: '身高',
            Weight: '体重',
            EnterWeightNotice: '请输入运动员体重',
            EnterHeightNotice: '请输入运动员身高',
            PhoneNumber: '电话号码',
            EnterPhoneNumberNotice: '请输入电话号码',
            RequiredNotice: '不能为空',
            PhoneNumberNotice: '请输入正确的号码格式',
            Email: '电子邮箱',
            EnterEmailNotice: '请输入电子邮箱',
            EmailNotice: '请输入正确的邮箱格式',
            PictureFileNotice: '请选择正确的图片文件',
            PictureSizeNotice: '选择图片请小于1M',
            Manage: '管理',
            Add: '+ 添加',
            Years: '岁',
            FormarError: '数据格式不正确',
            ViewDocument: '查看档案',
            AddToProject: '添加到项目',
            Record: '记录',
            LoadAll: '已加载全部资源',
            Reset: '重置',
            Invationing: '邀请记录',
            BatchExportIndicator: '批量导出指标',
            BatchExportRawData:'批量导出原始数据',
            Link: {
                Invitation: '邀请用户注册',
                FileName: '档案姓名',
                LoginEmail: '注册邮箱',
                InvitationLink: '邀请链接',
                SendInvitation: '发送邀请',
                CopyLink: '复制链接',
                LinkNotice: '用户提交资料才能完成档案创建',
                InvitationOther: '邀请其他人',
                Notice: '复制成功',
                Notice2: '复制失败',
                Notice3: '邀请发送成功',
                Notice4: '邀请发送失败',
                InvationNotice: '在输入运动员姓名和点击生成链接后，会将邀请链接直接发送到填写的邮箱中',
                Notice5: '请输入运动员名称',
            },
            Details: {
                RelationToProject: '添加到项目',
                ModifySocument: '修改资料',
                RelationRecord: '相关记录',
                None: '无',
                SwingSide: '击球手',
                PowerLeg: '发力腿',
                LeftHand: '左手',
                RightHand: '右手',
                LeftLeg: '左腿',
                RightLeg: '右腿',
                Left: '左',
                Right: '右',
                LeftRight: '左右',
                ShoeSize: '鞋码',
                Statistics: '数据统计',
                ClickNotice: '点击动作或数字查看详情',
                Unit: {
                    SwingSide: '手',
                    PowerLeg: '腿',
                    ShoeSize: '码',
                }
            },
            TestRecord: {
                TestRecord: '测试记录',
                StartDate: '开始日期',
                EndDate: '结束日期',
                SelectNotice: '请先选择测试系统',
                Time: '时间',
                None: '无',
                DataLength: '条记录',
            },
            Result: {
                Application8: {
                    'Swing': '摆臂',
                    'Akimbo': '叉腰',
                    'Other': '其他',
                    'Bilateral': '双侧',
                    'Left': '左侧',
                    'Right': '右侧',
                    'MidThighPull': '大腿中部硬拉',
                    '1_4Squat': '1/4蹲起',
                    'CalfRaise': '提踵',
                    'Customization': '自定义',
                    'ITest': 'I测试',
                    'YTest': 'Y测试',
                    'TTest': 'T测试',
                    'FreeMode': '自由模式',
                    'TimekeepingMode': '计时模式',
                    'UpperLimbs': '上肢',
                    'LowerLimbs': '下肢',
                    '力': '力',
                    '时间': '时间',
                    '速度/加速度': '速度/加速度',
                    '功率': '功率',
                    '位移': '位移',
                    '其他': '其他',
                    '冲量': '冲量',
                    '频率': '频率',
                    'Remark': '备注',
                    '': '',
                    '力发展速率': '力发展速率',
                    'ImportantLeftRightRatio': '重点左右分量对比',
                    'OtherLeftRightRatio': '其他左右分量对比',
                    'ArmWeight': '臂重'
                },
                SendNotice: '请选择发送内容',
                SendSuccessfully: '发送成功',
                EmailContent: '邮件内容',
                SendEmail: '发送邮件',
                ReceivingEmail: '接收邮箱',
                COPPosition: 'COP',
                ModelSetting: '模块设定',
                ModelType: '测试模块',
                L_Fz_COP: 'L-COP 连线',
                R_Fz_COP: 'R-COP 连线',
                Fz_COP: '合力-COP 连线',
                Left: '左',
                Right: '右',
                Fz: '合力',
                COP: 'COP视图',
                AllFz: '合力-Fz',
                Legend: '图例',
                Asi: '不对称指数',
                LeftRightRatio: '左-右占比',
                HistoryMax: '历史最高',
                Now: '当前',
                MainIndicators: '主要指标',
                OtherIndicators: '更多指标',
                ExtendedIndicators: '扩展指标',
                SingleView: '单次指标',
                NumberOfTimes: '次数',
                NoData: '未保存数据',
                GoBack: '返回',
                RawData: "下载原始记录",
                Export: '导出指标',
                Weight: '测试体重',
                Duration: '测试时长',
                GolfClubs: '使用球杆',
                Spacing: '站姿间距',
                LeftAngle: '左偏角',
                RightAngle: '右偏角',
                LeftLeg: '左腿',
                RightLeg: '右腿',
                ResultantForce: '合力',
                Limbs: '躯干',
                Side: '部位',
                Actions: '动作',
                Pose: '姿势',
                Order: '顺序',
                Joint: '关节',
                KneePosition: '膝盖位置',
                Times_L: '左脚次数',
                Times_R: '右脚次数',
                0: '默认',
                1: '左侧',
                2: '右侧',
                3: '先左后右',
                4: '先右后左',
                Unit: {
                    KneePosition: 'CM',
                    Times_L: '',
                    Times_R: '',
                    Spacing: 'CM',
                    Weight: 'KG',
                    Duration: 'S',
                    LeftAngle: '°',
                    RightAngle: '°'
                },
                OnceHeader: '第 T 次',
                ExportReport: '导出报告',
                Repetitions: '重复次数',
                ContainsPersonalRecords: "包含个人记录",
                MuscleStrengthAvgIndicator: {
                    最大峰值力: '最大峰值力',
                    平均峰值力: '平均峰值力',
                    到达峰值时间: '到达峰值时间',
                    峰值发力率: '峰值发力率',
                    峰值力: '峰值力'
                },
                '左侧最大范围': '左侧最大范围',
                '左侧最大范围时间': '左侧最大范围时间',
                '右侧最大范围': '右侧最大范围',
                '右侧最大范围时间': '右侧最大范围时间',
                '左侧平均范围': '左侧平均范围',
                '最大范围BSA': '最大范围BSA',
                '右侧平均范围': '右侧平均范围',
                '最大范围': '最大范围',
                '平均范围': '平均范围',
                '最大范围时间': '最大范围时间',
                Times: '次',
                NumberOfTests: '测试次数',
                LeftSide: '左侧',
                RightSide: '右侧',
                数值: "数值",
                ReferenceValue: '参考值',
                Internal: '内旋',
                External: '外旋',
                Adduction: '内收',
                Abduction: '外展',
                Varus: '内翻',
                Valgus: '外翻',
                MaximumForceRatio: '最大力值比',
                AvgForce: '峰值力平均值',
                MaxForce: '峰值力最大值',
                MaxImpulse: '最大冲量',
                AvgImpulse: '平均冲量',
                AvgForce_Baseline: '峰值力平均值(基线值)',
                MaxForce_Baseline: '峰值力最大值(基线值)',
                MaxImpulse_Baseline: '最大冲量(基线值)',
                AvgImpulse_Baseline: '平均冲量(基线值)',
            },
            Action: {
                Action: '动作数据',
                TrendChart: '趋势图',
                IndexNotice: '请选择查看的指标',
                RelationRecord: '相关记录',
                Delete: '删除',
                Export: '导出选中记录',
                None: '无',
                ExportData: '导出原始数据',
                ExportData1: '导出数据',
                EcportIndex: '导出指标',
                ExportReport: '导出报告',
                C3DReport: '导出C3D',
                ViewRecord: '查看记录',
                Index: '指标',
                Report: '报告',
                Data: '原始数据',
                Total: '共',
                Datas: '条数据',
                Max: '最大值',
                Min: '最小值',
                Notice: '请先选择记录',
                NoIndex: '暂无指标',
            },
            SingleCreate: '手动添加',
            DownloadTemplate: '下载导入模板',
            SubjectImportTemplate: "受试人导入模板",
            ImportFromTemplate: '模板批量导入',
            Template: '运动员批量导入模板',
            Upload: "导入",
            ImportSuccess: '导入成功',
            ImportFailed: '导入失败',
            Items: '项'
        },
        SportProjects: {
            SportProjects: '运动项目',
            AddSportProjectNotice: '运动项目仅用于区分运动员',
            ProjectName: '项目名称',
            AddProject: '添加项目',
            RelatedCount: '相关人数',
            Operate: '操作',
            RelatedAthletes: '相关运动员',
            AddSportProject: '添加运动项目',
            notice1: '至少选择一个',
            SelectApplications: '应用系统',
            ProNameNotice: '输入运动项目名称',
            addSuccessNotice: '运动项目添加成功',
            addFaildNotice: '运动项目添加失败',
            deleteSuccessNotice: '运动项目删除成功',
            deleteFaildNotice: '运动项目删除失败',
            updateSuccessNotice: '运动项目修改成功',
            updateFaildNotice: '运动项目修改失败',
            CreateSportProject: '创建运动项目',
            EmptyNotice: '请输入项目名称',
            People: '人',
            Name: '姓名',
            Gender: '性别',
            Birthday: '生日',
            ModifyName: '修改',
            ModifySportProject: '修改运动项目',
            modifySuccessNotice: '项目名称修改成功',
            modifyFaildNotice: '项目名称不能重复',
            AddSport: '管理运动员',
            Athletes: '运动员',
            QueryError: '查询失败',
            Added: '已添加',
            SaveFailNotice: '保存失败',
            SaveSuccessNotice: '保存成功',
            NotSaved: '内容未保存，请问是否离开',
            DeleteNotice: '确定要删除该运动项目吗？',
            Notice: '提示',
            DeleteProjcctNotice: '删除运动项目',
        }
    },
    Application: {
        Name: {
            1: '肌肉力量测试系统',
            5: '高尔夫技术诊断系统',
            6: "腘绳肌测试系统",
            7: '多功能测力架',
            8: '运动功能表现测试系统',
            9: '关节活动度'
        },
        Label: {
            Detail: "查看详情",
            SubjectCount: '运动员',
            RecordCount: '测试记录',
            ProjectCount: '测试项目',
            RankList: "排名展示",
            More: "更多>",
            TrendCharts: "测试趋势",
            Indicators: "展示指标",
            ExportIndicators: "导出指标",
            TrainingPlan: '训练计划',
            MostRecentRecord: '最近一次记录',
            AllRecords: '所有记录'
        },
        Options: {
            LastDays: "最近%d天"
        },
        Columns: {
            CreateTime: "创建时间"
        },
    },
    Report: {
        Label: {
            MinAvgMax: "最小/最大",
            ReportChart: "数据报告图表",
            Query: "筛选",
            Export: "导出",
            IndicatorOptions: "指标筛选",
            SubjectOptions: "选择运动员",
            MaxValue: "取最大值",
            MinValue: "取最小值",
            InsertChart: "增加图表",
            ModifyChart: "修改图表",
            true: '取最大值',
            false: '取最小值',
            指标: '指标',
            值: '值',
            单位: '单位'
        },
        Message: {
            IndicatorsEmpty: "请选择一个指标",
            SubjectEmpty: "请选择运动员"
        },
        Indicators: {
            峰值: '峰值',
            峰值时间: '峰值时间',
            最大发力率: '最大发力率',
            最大峰值力: '最大峰值力',
            平均峰值力: '平均峰值力',
            到达峰值时间: '到达峰值时间',
            峰值发力率: '峰值发力率',
            左脚平均峰值力: '左脚平均峰值力',
            右脚平均峰值力: '右脚平均峰值力',
            左脚最大力值: '左脚最大力值',
            右脚最大力值: '右脚最大力值',
            左脚重复次数: '左脚重复次数',
            右脚重复次数: '右脚重复次数',
            左重复次数: '左重复次数',
            右重复次数: '右重复次数',
            内收左重复次数: '内收左重复次数',
            内收右重复次数: '内收右重复次数',
            外展左重复次数: '外展左重复次数',
            外展右重复次数: '外展右重复次数',
            内旋左重复次数: '内旋左重复次数',
            内旋右重复次数: '内旋右重复次数',
            外旋左重复次数: '外旋左重复次数',
            外旋右重复次数: '外旋右重复次数',
            内翻左重复次数: '内翻左重复次数',
            内翻右重复次数: '内翻右重复次数',
            外翻左重复次数: '外翻左重复次数',
            外翻右重复次数: '外翻右重复次数',
            左最大力值: '左最大力值',
            右最大力值: '右最大力值',
            内收左最大力值: '内收左最大力值',
            内收右最大力值: '内收右最大力值',
            外展左最大力值: '外展左最大力值',
            外展右最大力值: '外展右最大力值',
            内旋左最大力值: '内旋左最大力值',
            内旋右最大力值: '内旋右最大力值',
            外旋左最大力值: '外旋左最大力值',
            外旋右最大力值: '外旋右最大力值',
            内翻左最大力值: '内翻左最大力值',
            内翻右最大力值: '内翻右最大力值',
            外翻左最大力值: '外翻左最大力值',
            外翻右最大力值: '外翻右最大力值',
            左脚扭矩: '左脚扭矩',
            右脚扭矩: '右脚扭矩',
            左脚峰值力最大值: '左脚峰值力最大值',
            右脚峰值力最大值: '右脚峰值力最大值',
            峰值力最大值BSA: '峰值力最大值BSA',
            左脚峰值力平均值: '左脚峰值力平均值',
            右脚峰值力平均值: '右脚峰值力平均值',
            峰值力平均值BSA: '峰值力平均值BSA',
            左脚冲量平均值: '左脚冲量平均值',
            右脚冲量平均值: '右脚冲量平均值',
            冲量平均值BSA: '冲量平均值BSA',
            左脚冲量最大值: '左脚冲量最大值',
            右脚冲量最大值: '右脚冲量最大值',
            冲量最大值BSA: '冲量最大值BSA',


            'Absolute': '绝对值',
            'Relative': '相对值',
            'LeftComponent': '左侧分量',
            'RightComponent': '右侧分量',
            '缓冲最小力值': '缓冲最小力值',
            '制动最大力值': '制动最大力值',
            '蹬伸最大力值': '蹬伸最大力值',
            '落地最大力值': '落地最大力值',
            '离心制动阶段发力率': '离心制动阶段发力率',
            '制动最大力值发力率': '制动最大力值发力率',
            '蹬伸平均功率': '蹬伸平均功率',
            '蹬伸峰值功率': '蹬伸峰值功率',
            '离心制动阶段冲量': '离心制动阶段冲量',
            '向心阶段净冲量': '向心阶段净冲量',
            '下蹲时间': '下蹲时间',
            '制动时间': '制动时间',
            '蹬伸时间': '蹬伸时间',
            '蹬伸与制动时间比': '蹬伸与制动时间比',
            '峰值功率发生时刻': '峰值功率发生时刻',
            '触地时间': '触地时间',
            '腾空时间': '腾空时间',
            '落地稳定时间': '落地稳定时间',
            '下蹲平均速度': '下蹲平均速度',
            '离心阶段峰值速度': '离心阶段峰值速度',
            '向心阶段最大速度': '向心阶段最大速度',
            '峰值功率发生时速度': '峰值功率发生时速度',
            '起跳速度': '起跳速度',
            '腾空高度Hv': '腾空高度Hv',
            '腾空高度': '腾空高度',
            '腾空高度Ht': '腾空高度Ht',
            '腾空高度HFt': '腾空高度HFt',
            '下蹲深度': '下蹲深度',
            '反应力量指数RSI': '反应力量指数RSI',
            '反应力量指数RSImod': '反应力量指数RSImod',
            '动态力量指数DSI': '动态力量指数DSI',
            '左侧动态力量指数DSI': '左侧动态力量指数DSI',
            '右侧动态力量指数DSI': '右侧动态力量指数DSI',
            '离心利用率EUR': '离心利用率EUR',
            '预拉伸增强百分比PSAP': '预拉伸增强百分比PSAP',
            '弹性指数ESI': '弹性指数ESI',
            '落地表现指数': '落地表现指数',
            '最大蹬伸力发力率': '最大蹬伸力发力率',
            '跌落峰值力': '跌落峰值力',
            '左侧跌落峰值力': '左侧跌落峰值力',
            '右侧跌落峰值力': '右侧跌落峰值力',
            '蹬伸峰值力': '蹬伸峰值力',
            '跌落峰值力加载率': '跌落峰值力加载率',
            '左侧跌落峰值力加载率': '左侧跌落峰值力加载率',
            '右侧跌落峰值力加载率': '右侧跌落峰值力加载率',
            '蹬伸峰值力发力率': '蹬伸峰值力发力率',
            '离心阶段冲量': '离心阶段冲量',
            '跌落峰值力到达时间': '跌落峰值力到达时间',
            '左侧跌落峰值力到达时间': '左侧跌落峰值力到达时间',
            '右侧跌落峰值力到达时间': '右侧跌落峰值力到达时间',
            '蹬伸峰值加速度': '蹬伸峰值加速度',
            '绝对最大力值': '绝对最大力值',
            '单位体重最大力值': '单位体重最大力值',
            '左侧最大力值': '左侧最大力值',
            '右侧最大力值': '右侧最大力值',
            '50ms发力率': '50ms发力率',
            '100ms发力率': '100ms发力率',
            '150ms发力率': '150ms发力率',
            '200ms发力率': '200ms发力率',
            '250ms发力率': '250ms发力率',
            '300ms发力率': '300ms发力率',
            '50ms冲量': '50ms冲量',
            '100ms冲量': '100ms冲量',
            '150ms冲量': '150ms冲量',
            '200ms冲量': '200ms冲量',
            '250ms冲量': '250ms冲量',
            '300ms冲量': '300ms冲量',
            '到达最大力值时间': '到达最大力值时间',
            '左侧到达最大力值时间': '左侧到达最大力值时间',
            '右侧到达最大力值时间': '右侧到达最大力值时间',
            '平均缓冲最大力值': '平均缓冲最大力值',
            '平均蹬伸最大力值': '平均蹬伸最大力值',
            '平均缓冲最大力值加载率': '平均缓冲最大力值加载率',
            '平均缓冲时间': '平均缓冲时间',
            '平均蹬伸时间': '平均蹬伸时间',
            '平均触地时间': '平均触地时间',
            '平均腾空时间': '平均腾空时间',
            '平均起跳速度': '平均起跳速度',
            '平均腾空高度': '平均腾空高度',
            '平均蹬伸功率': '平均蹬伸功率',
            '平均蹬伸峰值功率': '平均蹬伸峰值功率',
            '平均下蹲速度': '平均下蹲速度',
            '平均下蹲深度': '平均下蹲深度',
            '缓冲最大力值': '缓冲最大力值',
            '缓冲最大力值加载率': '缓冲最大力值加载率',
            '蹬伸功率': '蹬伸功率',
            '缓冲时间': '缓冲时间',
            '下蹲速度': '下蹲速度',
            '蹲起时间': '蹲起时间',
            '下蹲和蹬伸时间比': '下蹲和蹬伸时间比',
            '平均击打峰值力': '平均击打峰值力',
            '平均击打时间': '平均击打时间',
            '平均撤离时间': '平均撤离时间',
            '频率': '频率',
            '初段平均频率': '初段平均频率',
            '中段平均频率': '中段平均频率',
            '末段平均频率': '末段平均频率',
            '最小自由频率': '最小自由频率',
            '最大自由频率': '最大自由频率',
            '总计次数': '总计次数',
            '耐力指数': '耐力指数',
            '疲劳指数': '疲劳指数',
            '落地峰值力': '落地峰值力',
            '左侧落地峰值力': '左侧落地峰值力',
            '右侧落地峰值力': '右侧落地峰值力',
            '落地峰值力加载率': '落地峰值力加载率',
            '左侧落地峰值力加载率': '左侧落地峰值力加载率',
            '右侧落地峰值力加载率': '右侧落地峰值力加载率',
            '落地峰值力到达时间': '落地峰值力到达时间',
            '左侧落地峰值力到达时间': '左侧落地峰值力到达时间',
            '右侧落地峰值力到达时间': '右侧落地峰值力到达时间',
            '落地到恢复稳定时间': '落地到恢复稳定时间',
            '触地时间差': '触地时间差',
            '左右摇晃速度': '左右摇晃速度',
            '前后摇晃速度': '前后摇晃速度',
            '总体摇晃速度': '总体摇晃速度',
            '左右晃动幅度': '左右晃动幅度',
            '前后晃动幅度': '前后晃动幅度',
            '左右摇晃幅度': '左右摇晃幅度',
            '前后摇晃幅度': '前后摇晃幅度',
            '落地顺序': '落地顺序',
            '左右平均摇晃速度': '左右平均摇晃速度',
            '前后平均摇晃速度': '前后平均摇晃速度',
            '总体平均摇晃速度': '总体平均摇晃速度',
            '左右摇晃轨迹长度': '左右摇晃轨迹长度',
            '前后摇晃轨迹长度': '前后摇晃轨迹长度',
            '总体摇晃轨迹长度': '总体摇晃轨迹长度',
            '左右摇晃最大幅度': '左右摇晃最大幅度',
            '前后摇晃最大幅度': '前后摇晃最大幅度',
            '轨迹包络面积': '轨迹包络面积',
            '最大净力值': '最大净力值',
            '最大力值': '最大力值',
            '最小力值': '最小力值',
            '平均力': '平均力',
            '冲量': '冲量',
            '上箱高度Ht': '上箱高度Ht',
            '平均反应力量指数RSI': '平均反应力量指数RSI',
            '缓冲最小力值分量': '缓冲最小力值分量',
            '制动最大力值分量': '制动最大力值分量',
            '蹬伸最大力值分量': '蹬伸最大力值分量',
            '落地最大力值分量': '落地最大力值分量',
            '离心制动阶段发力率分量': '离心制动阶段发力率分量',
            '制动最大力值发力率分量': '制动最大力值发力率分量',
            '蹬伸平均功率分量': '蹬伸平均功率分量',
            '蹬伸峰值功率分量': '蹬伸峰值功率分量',
            '离心制动阶段冲量分量': '离心制动阶段冲量分量',
            '向心阶段净冲量分量': '向心阶段净冲量分量',
            '最大蹬伸力发力率分量': '最大蹬伸力发力率分量',
            '跌落峰值力分量': '跌落峰值力分量',
            '蹬伸峰值力分量': '蹬伸峰值力分量',
            '跌落峰值力加载率分量': '跌落峰值力加载率分量',
            '蹬伸峰值力发力率分量': '蹬伸峰值力发力率分量',
            '离心阶段冲量分量': '离心阶段冲量分量',
            '绝对最大力值分量': '绝对最大力值分量',
            '单位体重最大力值分量': '单位体重最大力值分量',
            '50ms发力率分量': '50ms发力率分量',
            '100ms发力率分量': '100ms发力率分量',
            '150ms发力率分量': '150ms发力率分量',
            '200ms发力率分量': '200ms发力率分量',
            '250ms发力率分量': '250ms发力率分量',
            '300ms发力率分量': '300ms发力率分量',
            '50ms冲量分量': '50ms冲量分量',
            '100ms冲量分量': '100ms冲量分量',
            '150ms冲量分量': '150ms冲量分量',
            '200ms冲量分量': '200ms冲量分量',
            '250ms冲量分量': '250ms冲量分量',
            '300ms冲量分量': '300ms冲量分量',
            '平均缓冲最大力值分量': '平均缓冲最大力值分量',
            '平均蹬伸最大力值分量': '平均蹬伸最大力值分量',
            '平均缓冲最大力值加载率分量': '平均缓冲最大力值加载率分量',
            '平均蹬伸功率分量': '平均蹬伸功率分量',
            '平均蹬伸峰值功率分量': '平均蹬伸峰值功率分量',
            '缓冲最大力值分量': '缓冲最大力值分量',
            '平均击打峰值力分量': '平均击打峰值力分量',
            '平均击打时间分量': '平均击打时间分量',
            '平均撤离时间分量': '平均撤离时间分量',
            '落地峰值力分量': '落地峰值力分量',
            '落地峰值力加载率分量': '落地峰值力加载率分量',
            '最大力值分量': '最大力值分量',
            '最小力值分量': '最小力值分量',
            '平均力分量': '平均力分量',
            '冲量分量': '冲量分量',
            '动态反弹指数DRI': '动态反弹指数DRI',
            '平均反应力量指数RSImod': '平均反应力量指数RSImod',
            '': ''
        }
    },
    UserManagement: {
        Label: {
            Member: "成员",
            Disabled: "已禁用用户",
            SelectRole: "选择角色",
            SelectGroup: "选择权限组",
            FilterByAccountName: "按账号或用户名搜索",
            BatchOperate: "批量处理",
            CreateAccount: "添加新用户",
            Enanble: "恢复用户",
            Disable: "禁用用户",
            Delete: "彻底删除",
            Permission: "权限",
            Information: "修改资料",
            Role: "角色",
            PermissionGroup: "权限组",
            DefaultGroup: "默认组",
            Account: "账号",
            Password: "密码",
            Name: "姓名",
            ModifyPermission: "修改用户权限",
            ModifyAccountInfo: "修改用户信息",
            Prev: "上一页",
            Next: "下一页",
            CreateConfirm: "创建用户",
        },
        Columns: {
            AvatarAccount: "头像/账号",
            UserName: "姓名",
            CreateTime: "创建时间",
            RolePermission: "角色/权限",
            Operate: "操作"
        },
        Message: {
            LengthNotice: '请输入8到16位',
            AccountFillNotice: '密码为邮箱格式',
            ConfirmDisable: "确认要禁用该用户吗?",
            ConfirmEnable: "确认要恢复该用户吗?",
            ConfirmDelete: "确认要彻底删除该用户吗?",
            ConfirmPermissionModify: "确认要修改该用户权限吗?",
            ConfirmModifyAccountInfo: "确认保存?",
            PermissionModifySuccess: "权限修改成功",
            PWNotice: '密码不能为空',
            NameNotice: '姓名不能为空',
        }
    },
    Role: {
        0: "运动员",
        1: '教练员',
        63: '管理员',
        127: '运维人员',
        255: '超级管理员',
        Subject: "运动员",
        Coach: "教练员",
        Admin: "管理员",
        OM: "运维人员",
    },
    Gender: {
        0: "男",
        1: "女",
        2: '其他'
    },
    ActionModel: {
        RecordCount: '记录数',
        ProjectCount: '项目数',
        Nordic: '北欧式',
        Razor: '剃刀式',
        IsometricContraction_0: '0°等长收缩',
        IsometricContraction_30: '30°等长收缩',
        IsometricContraction_60: '60°等长收缩',
        Irons: "铁杆",
        Woods: "木杆",
        Wedges: "挖起杆",
        Hybrids: "铁木杆",
        Putter: "推杆",
        Iron1: "1号铁",
        Iron2: "2号铁",
        Iron3: "3号铁",
        Iron4: "4号铁",
        Iron5: "5号铁",
        Iron6: "6号铁",
        Iron7: "7号铁",
        Iron8: "8号铁",
        Iron9: "9号铁",
        Iron10: "10号铁",
        Driver: "开球木",
        Wood3: "3号木",
        Wood5: "5号木",
        Wood7: "7号木",
        Wood9: "9号木",
        Pitch: "劈起杆",
        Wedge48: "48°挖起杆",
        Wedge50: "50°挖起杆",
        Wedge52: "52°挖起杆",
        Wedge54: "54°挖起杆",
        Wedge56: "56°挖起杆",
        Wedge58: "58°挖起杆",
        Wedge60: "60°挖起杆",
        Wedge62: "62°挖起杆",
        Hybrid1: "1号铁木杆",
        Hybrid2: "2号铁木杆",
        Hybrid3: "3号铁木杆",
        Hybrid4: "4号铁木杆",
        Hybrid5: "5号铁木杆",
        Hybrid6: "6号铁木杆",
        Hybrid7: "7号铁木杆",
        '1': '颈部',
        '2': '向前弯曲',
        '3': '后仰',
        '4': '向左弯曲',
        '5': '向右弯曲',
        '6': '坐姿',
        '7': '坐姿',
        '8': '坐姿',
        '9': '坐姿',
        '10': '肩部',
        '11': '左侧',
        '12': '右侧',
        '13': '内旋',
        '14': '外旋',
        '15': '内收',
        '16': '外展',
        '17': '前屈',
        '18': '后伸',
        '19': 'ISO I测试',
        '20': 'ISO Y测试',
        '21': 'ISO T测试',
        '22': '坐姿-90°肘部屈',
        '23': '坐姿-90°肘部屈90°肩外展',
        '24': '站姿-肘部90°',
        '25': '站姿-90°肘部屈90°肩外展90°肩外旋',
        '26': '仰卧-90°肘部屈90°肩外展',
        '27': '仰卧-90°肘部屈',
        '28': '俯卧',
        '29': '坐姿-90°肘部屈',
        '30': '坐姿90°肘部屈90°肩外展',
        '31': '站姿-90°肘部屈',
        '32': '站姿-90°肘部屈-90°肩外展',
        '33': '仰卧-90°肘部屈-90°肩外展',
        '34': '仰卧-90°肘部屈',
        '35': '俯卧',
        '36': '坐姿',
        '37': '站姿',
        '38': '坐姿',
        '39': '站姿',
        '40': '侧卧',
        '41': '坐姿-90°肩部外展',
        '42': '站姿',
        '43': '站姿-90°肘部屈',
        '44': '坐姿',
        '45': '站姿',
        '46': '坐姿-90°肩部屈',
        '47': '站姿-90°肩部屈',
        '48': '仰卧',
        '49': '仰卧',
        '50': '俯卧',
        '51': '仰卧',
        '52': '俯卧',
        '53': '仰卧',
        '54': '俯卧',
        '55': '躯干',
        '56': '向前弯曲',
        '57': '向左弯曲',
        '58': '向右弯曲',
        '59': '坐姿',
        '60': '坐姿',
        '61': '坐姿',
        '62': '髋部',
        '63': '左侧',
        '64': '右侧',
        '65': '前屈',
        '66': '后伸',
        '67': '内旋',
        '68': '外旋',
        '69': '内收',
        '70': '外展',
        '71': '站姿',
        '72': '俯卧',
        '73': '俯卧-90°膝部屈',
        '74': '半俯卧',
        '75': '站姿',
        '76': '仰卧',
        '77': '坐姿',
        '78': '坐姿',
        '79': '仰卧',
        '80': '俯卧',
        '81': '坐姿',
        '82': '仰卧',
        '83': '俯卧',
        '84': '仰卧',
        '85': '仰卧-45°屈膝',
        '86': '仰卧-肘部90°',
        '87': '仰卧',
        '88': '仰卧-45°屈膝',
        '89': '仰卧-肘部90°',
        '90': '侧卧',
        '91': '肘部',
        '92': '左侧',
        '93': '右侧',
        '94': '前屈',
        '95': '后伸',
        '96': '坐姿-90°肘部屈-腕关节中立位',
        '97': '坐姿-90°肘部屈-腕关节旋前',
        '98': '坐姿-90°肘部屈-腕关节旋后',
        '99': '坐姿-90°肘部屈90°肩外展-腕关节中立位',
        '100': '坐姿-90°肘部屈90°肩外展-腕关节旋前',
        '101': '站姿-90°肘部屈-腕关节中立位',
        '102': '坐姿-90°肘部屈',
        '103': '腕部',
        '104': '左侧',
        '105': '右侧',
        '106': '旋后',
        '107': '旋前',
        '108': '前屈',
        '109': '后伸',
        '110': '尺侧偏转',
        '111': '桡侧偏转',
        '112': '90°肘部屈-腕关节中立位',
        '113': '90°肘部屈-腕关节中立位',
        '114': '90°肘部屈-腕关节中立位',
        '115': '90°肘部屈-腕关节中立位',
        '116': '90°肘部屈-腕关节中立位',
        '117': '90°肘部屈-腕关节旋前',
        '118': '90°肘部屈-腕关节旋后',
        '119': '90°肘部屈-腕关节中立位',
        '120': '90°肘部屈-腕关节旋前',
        '121': '90°肘部屈-腕关节旋后',
        '122': '手',
        '123': '左侧',
        '124': '右侧',
        '125': '握力',
        '126': '坐姿-90°肘部屈-腕关节中立位',
        '127': '坐姿-腕关节中立位',
        '128': '坐姿-90°肩部屈-腕关节中立位',
        '129': '膝部',
        '130': '左侧',
        '131': '右侧',
        '132': '屈曲',
        '133': '伸展',
        '134': '坐姿',
        '135': '俯卧',
        '136': '仰卧',
        '137': '坐姿-90°屈膝',
        '138': '俯卧-90°屈膝',
        '139': '仰卧',
        '140': '踝部',
        '141': '左侧',
        '142': '右侧',
        '143': '内翻',
        '144': '外翻',
        '145': '背屈',
        '146': '跖屈',
        '147': '直腿坐',
        '148': '直腿坐',
        '149': '直腿坐',
        '150': '直腿坐',
        '151': '足',
        '152': '左侧',
        '153': '右侧',
        '154': '趾屈',
        '155': '趾伸',
        '156': '坐姿',
        '157': '直腿坐-跖屈',
        '158': '直腿坐-跖中立',
        '159': '坐姿',
        '160': '直腿坐-跖中立',
        '161': '直腿坐-跖屈',
        '162': '站姿',
        '163': '仰卧',
        '164': '站姿',
        '165': '仰卧',
        '166': '站姿',
        '167': '仰卧',
        '168': '站姿',
        '169': '仰卧',
        '170': '侧卧',
        '171': '侧卧',
        '172': '肩胛上提',
        '173': '肩胛前伸',
        '174': '肩胛后缩',
        '175': '坐姿',
        '176': '坐姿',
        '177': '坐姿',
        '178': '坐姿-90°肘部屈',
        '179': '站姿-90°肘部屈',
        '180': '仰卧-90°肘部屈',
        '181': '坐姿-90°肘部屈',
        '182': '站姿-90°肘部屈',
        '183': '俯卧',
        '184': '坐姿-90°肩外展',
        '185': '坐姿-90°肩外展-90°肘部屈',
        '186': '坐姿-90°肘部屈',
        '187': '坐姿-90°肩外展-90°肘部屈',
        '188': '站姿-90°肘部屈',
        '189': '侧卧-90°肘部屈',
        '190': '坐姿-90°肘部屈90°肩外展90°肩外旋',
        '191': '坐姿-90°肘部屈90°肩外展90°肩外旋',
        '192': '侧卧-90°肘部屈',
        '193': '站姿-90°肘部屈-腕关节旋前',
        '194': '站姿-90°肘部屈-腕关节旋后',
        '195': '站姿-90°肘部屈',
        '197': '其他',
        '198': '站姿-90°屈膝',
        '199': '坐姿-45°屈膝',
        '200': '半仰卧',
        '201': '俯卧-45°屈膝',
        '205': '大腿中部硬拉',
        '206': '站姿',
        '207': '90°肘部屈-腕关节旋后',
        '208': '90°肘部屈-腕关节旋前',
        'Hip_Joint': '髋关节',
        'Buckling': '屈曲',
        'Stand_Straight': '站姿直腿',
        'Stand_Knees_Kick': '站姿屈膝踢腿',
        'Stomach_Knees_30': '俯卧屈膝30°',
        'Sit_Knees_90': '坐姿屈膝90°',
        'Back_Knees_90': '仰卧屈膝90°',
        'Spread': '伸展',
        'Stomach_Knees_Thigh': '俯卧屈膝90°-大腿后侧',
        'Stand_Upright_Ankle': '站姿直腿-脚踝',
        'Adduction_Abduction': '内收/外展',
        'Back_Knees_120': '仰卧屈膝120°',
        'Back_Knees_135': '仰卧屈膝135°',
        'Stance_Ankles': '站姿-脚踝处',
        'Standing_Knees': '站姿-膝盖处',
        'Back_Ankles': '仰卧-脚踝处',
        'Back_Knees': '仰卧-膝盖处',
        'Internal_External': '内旋/外旋',
        'Stomach_Knees_90': '俯卧屈膝90°',
        'Knee_Joint': '膝关节',
        'Stomach_Knees_45': '俯卧屈膝45°',
        'Stand_Knees_90': '站姿屈膝90°',
        'Back_Knees_45': '仰卧屈膝45°',
        'Sit_Knees_10': '坐姿屈膝10°',
        'Sit_Knees_45': '坐姿屈膝45°',
        'Back_Knees_10': '仰卧屈膝10°',
        'Ankle_Joint': '踝关节',
        'Dorsiflexion': '背屈',
        'Sitting_Position': '坐姿',
        'Varus_Valgus': '内翻/外翻',
        'Back_StraightLegs': '仰卧直腿',
        'Toe_Flexion': '趾屈',
        'Lie_Supine': '仰卧',
        'Shoulder_Joint': '肩关节',
        'Stomach_Straight': '俯卧直臂',
        'Abduction': '外展',
        'Side_Straight': '侧卧-直臂',
        'Adduction': '内收',
        'Shoulder_Elbow': '仰卧-肩外展90°屈肘90°',
        'Elbow_Neutral': '仰卧-中立位屈肘90°',
        'Articulatio_Cubiti': '肘关节',
        'Sit_Elbows_90': '坐姿屈肘90°',
        'Neck': '颈部',
        'Default_Position': '默认姿势',
        'Lateral_Flexion': '侧屈',
        'Other': '其他',
        'Upper_Push': '上肢推',
        Default: '默认',
        Left: '左',
        Right: '右',
        Left_To_Right: '先左后右',
        Right_To_Left: '先右后左',
        simultaneously: '左右同时',
        Null: '无',
        'CMJ': '下蹲跳',
        'SJ': '蹲跳',
        'DropJump': '跌落跳',
        'MVC': '最大自主收缩',
        'RepetitiveHopping': '连续直腿跳',
        'RepetitiveCMJ': '连续下蹲跳',
        'Squat': '蹲起',
        'Stamping': '上下运动频率和耐力测试',
        'Landing': '落地测试',
        'Balance': '平衡测试',
        'AthleticShoulder': '肩关节测试',
        'Free': '自由测试',
        'DJ': '跳深',
        'Inside': '内',
        'Outside': '外',
        '踝关节': '踝关节',
        '肘关节': '肘关节',
        '髋关节': '髋关节',
        '颈部': '颈部',
        '肩关节': '肩关节',
        '躯干': '躯干',
        '膝关节': '膝关节',
        '腕关节': '腕关节',
        '腕关节尺偏': '腕关节尺偏',
        '髋关节外旋': '髋关节外旋',
        '髋关节内收': '髋关节内收',
        '髋关节外展': '髋关节外展',
        '颈部屈曲': '颈部屈曲',
        '颈部伸展': '颈部伸展',
        '颈部侧屈': '颈部侧屈',
        '颈部旋转': '颈部旋转',
        '肩关节内旋': '肩关节内旋',
        '肩关节外旋': '肩关节外旋',
        '肩关节屈曲': '肩关节屈曲',
        '踝内翻': '踝内翻',
        '踝外翻': '踝外翻',
        '足背屈': '足背屈',
        '足跖屈': '足跖屈',
        '肘伸展': '肘伸展',
        '肘屈曲': '肘屈曲',
        '髋关节伸展': '髋关节伸展',
        '髋关节屈曲': '髋关节屈曲',
        '髋关节内旋': '髋关节内旋',
        '肩关节外展': '肩关节外展',
        '躯干伸展': '躯干伸展',
        '躯干侧屈': '躯干侧屈',
        '膝关节屈曲': '膝关节屈曲',
        '膝关节伸展': '膝关节伸展',
        '腕关节桡偏': '腕关节桡偏',
        '肩关节水平内收': '肩关节水平内收',
        '肩关节水平外展': '肩关节水平外展',
        '肩关节伸展': '肩关节伸展',
        '躯干屈曲': '躯干屈曲',
        '躯干旋转': '躯干旋转',
        '腕关节旋前': '腕关节旋前',
        '肩关节内收': '肩关节内收',
        '腕关节旋后': '腕关节旋后',
        '腕关节屈曲': '腕关节屈曲',
        '腕关节伸展': '腕关节伸展',
        '仰卧位': '仰卧位',
        '仰卧位（直腿）': '仰卧位（直腿）',
        '仰卧位（肘屈曲 90°）': '仰卧位（肘屈曲 90°）',
        '仰卧位（肩外展 90° - 肘屈曲 90°）': '仰卧位（肩外展 90° - 肘屈曲 90°）',
        '侧卧位': '侧卧位',
        '俯卧位': '俯卧位',
        '俯卧位（肩外展 90° - 肘屈曲 90°）': '俯卧位（肩外展 90° - 肘屈曲 90°）',
        '半跪姿': '半跪姿',
        '坐位': '坐位',
        '坐位（肘屈曲 90°）': '坐位（肘屈曲 90°）',
        '坐位（肩外展 90° - 肘屈曲 90°）': '坐位（肩外展 90° - 肘屈曲 90°）',
        '站立位': '站立位',
        '站立位（肘屈曲 90°）': '站立位（肘屈曲 90°）',
        '站立位（肩外展 90° - 肘屈曲 90°）': '站立位（肩外展 90° - 肘屈曲 90°）',
        '肘屈曲90°': '肘屈曲90°',
        '长坐位（无跖屈）': '长坐位（无跖屈）',
        '长坐位（跖屈）': '长坐位（跖屈）',
        '动作模块': '动作模块',
        Wrist: '腕部',
        Flexion: '前屈',
        Extension: '后伸',
        Supination: '旋后',
        Pronation: '旋前',
        Ulnar_Deviation: '尺侧偏转',
        Radial_Deviation: '桡侧偏转',
        Wrist_Neutral: '90°肘部屈-腕关节中立位',
        Wrist_Supination: '90°肘部屈-腕关节旋后',
        Wrist_Pronation: '90°肘部屈-腕关节旋前'
    },
    StandardData: {
        Title: "标准值管理(便携肌力)",
        Assembly: "动作组合",
        Limbs: '躯干',
        Actions: '动作',
        Pose: '姿势',
        Gender: '性别',
        Age: '年龄',
        PeakForce: '峰值力 N/kg',
        Modify: '设定标准值',
        FileBrowsing: '文件浏览',
        FileRequired: '请选择要导入的文件',
        DropFileHere: '拖入文件',
        clickToUpload: '点击上传',
        SportTitle: '标准值管理(运动功能表现)',
        Mean: '均值',
        Outstanding: '优秀值',
        '青少年': '青少年',
        '18~30': '18~30',
        '31~45': '31~45',
        '46~60': '46~60',
        'AgeGroup': '年龄段',
        ModifySuccess: '修改成功',
        ErrorRaw: '错误行',
        ErrorInfo: '错误信息',
        ErrorCount: '错误数量',
        Sure: '确定',
        ErrorStatistics: '错误统计',
        EmptyId: 'Id不能为空',
        IdParseError: 'Id无效',
        EmptyValue: '标准值不能为空',
        InvalidId: 'Id无效',
        ValueParseError: '标准值无效'
    },
    Project: {
        Public: '公开',
        Private: '私有',
        Title: '测试项目',
        FilterName: '按项目名称搜索',
        FilterSubject: '按受试人名称搜索',
        Columns: {
            CreateTime: '创建时间',
            ProjectName: '项目名称',
            CreatorName: '创建人',
            Operate: '操作',
            Name: '姓名',
            Gender: '性别',
            Age: '年龄',
            SubjectName: '受试人',
            Model: '测试动作'
        },
        RecordView: '记录',
        Batch: '批量操作',
        BatchDelete: '批量删除',
        DeleteEmptyNotice: '请选择要删除的内容',
        Finish: '完成',
        Create: '创建测试项目',
        View: '测试项目',
        ProjectName: '项目名称',
        Subjects: '受试人',
        AddSubject: '添加受试人',
        PublicProject: '公开项目',
        PrivateProject: '私有项目',
        ProjectType: '项目类型',
        CreateTime: '创建时间',
        CreateProject: '创建项目',
        Save: '保存修改',
        ProjectSubjectList: '项目中受试人',
        NameFilter: '姓名搜索',
        CreateSuccess: '创建成功',
        ModifySuccess: '修改成功',
        DeleteSuccess: '删除成功',
        DeleteFailed: '删除失败',
        NameTooLong: '名称过长,请不要超过24个字符',
        RequireName: '请输入项目名称',
        SubjectManagerment: '受试人管理',
        Added: '已添加',
        DeleteConfirm: '删除项目会同步删除相关测试记录,确认要继续吗?',
        ConfirmToDeleteRow: '确认要删除这条记录吗?',
        ConfromToDeleteSubjetc: '取消受试人会同步删除相关测试记录,确认要继续吗?',
        DoNotAskAgain: '不再提示'
    },
    TrainingPlan: {
        Title: '训练计划',
        PlanType: '类型',
        Public: '公开',
        Private: '私有',
        PlanName: '计划名称',
        Columns: {
            CreateTime: '创建时间',
            PlanName: '计划名称',
            CreatorName: '创建人',
            Operate: '操作',
            ActionCount: '动作数量',
            Seq: '序号',
            Action: '动作',
            ActionTimes: '重复次数',
            SubjectName: '受试人姓名',
            Completeness: '完成度',
            UsedTimes: '测试次数',
            Model: '测试动作',
            Gender: '性别'
        },
        Skipped: '已跳过',
        RecordView: '记录',
        Batch: '批量操作',
        BatchDelete: '批量删除',
        Finish: '完成',
        Create: '创建训练计划',
        Modify: '修改',
        Actions: '动作',
        Subjects: '受试人',
        Records: '测试记录',
        Statue: '是否完成',
        Finished: '已完成',
        Unfinish: '未完成',
        FilterName: '按计划名称搜索',
        RequireName: '请输入计划名称',
        NameTooLong: '名称过长,请不要超过50个字符',
        deleteRecord: '删除记录',
        DeleteConfirm: '操作会同步删除相关测试记录,确认要继续吗?',
        AddAction: '添加动作',
        TestActions: '测试动作',
        CreatePlan: '创建训练计划',
        SavePlan: '保存测试计划',
        Action: '动作',
        Times: '次数',
        ActionAssembly: '动作组合',
        RequireAssembly: '请选择动作',
        ConfirmDeleteAction: '确认要删除动作吗',
    },
    // 运动表现标记线信息
    '动作开始': '动作开始',
    '峰值': '峰值',
    '离地': '离地',
    '落地': '落地',
    '开始': '开始',
    '制动': '制动',
    '最低点': '最低点',
    '落地峰值': '落地峰值',
    '动作结束': '动作结束',
    '跌落峰值': '跌落峰值',
    '蹬伸峰值': '蹬伸峰值',
    '左侧最大力值': '左侧最大力值',
    '右侧最大力值': '右侧最大力值',
    '50ms': '50ms',
    '100ms': '100ms',
    '150ms': '150ms',
    '200ms': '200ms',
    '250ms': '250ms',
    '300ms': '300ms',
    'TFmin': 'TFmin',
    'T1': 'T1',
    'TStart': 'TStart',
    'TEnd': 'TEnd',
    'PO': 'PO',
    '触地': '触地',
    '稳定': '稳定',
    '最大垂直力值': '最大垂直力值',
    'A': 'A',
    'B': 'B',
    'C': 'C',
    'D': 'D',
    'E': 'E',
    '制动时刻': '制动时刻',
    '起跳时刻': '起跳时刻',
    '蹬伸': '蹬伸',
    '结束': '结束',
    //错误信息
    DefaultGroup: "默认组",
    Empty_PhoneNumber: "请输入手机号",
    Duplicate_PhoneNumber: "手机号重复,无法再次绑定",
    Invalid_BOMType: "模组类型不存在!",
    InsertFailed_Assembly: "动作新增失败!",
    Invalid_BOM: "模组不存在!",
    InsertFailed_BOM: "模组新增失败!",
    UpdateFailed_BOM: "模组更新失败!",
    DeleteFailed_BOM: "模组删除失败!",
    Invalid_Project: "项目不存在!",
    Invalid_Subject: "受试人不存在!",
    Exsist_Account: "账户已存在!",
    Invalid_Account: "账户不存在!",
    Incorrect_OldPassword: "旧密码不正确!",
    Invalid_Company: "找不到该公司!",
    Invalid_CompanyID: "无效的公司代码!",
    Incorrect_ApplicationCode: "无效的App代码!",
    Incorrect_AccountOrPassword: "用户名或密码错误!",
    Expired_Captcha: "验证码已过期!",
    Incorrect_Captcha: "验证码错误!",
    Failed_SendCaptcha: "验证码发送失败!",
    Invalid_Captcha: "无效的验证码!",
    Empty_SubjectName: "请输入受试者姓名!",
    Repeat_SubjectName: "已存在同名受试者!",
    Duplicate_Requests: "请求过于频繁,请稍后再试",
    UnknownError_Account: "当前用户不存在!",
    Locked_Company: "组织/公司已锁定!",
    Expired_Authorization: "组织/公司应用授权已过期!",
    Invalid_Authorization: "组织/公司应用授权未开通!",
    Invalid_Parameter: "无效的参数!",
    Invalid_License: "许可证无效!",
    Binded_License: "许可证已在其他设备绑定!",
    Unbind_License: "许可证尚未绑定!",
    Expired_License: "许可证已过期!",
    Failed_License: "许可证验证失败!",
    Empty_ApplictionCode: "应用编号缺失!",
    Invalid_ApplictionCode: "应用编号无效!",
    Invalid_ApplictionEndPoint: "无效的系统节点",
    Older_Version: "较旧的版本号",
    Empty_Version: "无有效的版本号",
    Duplicate_ApplicationCode: "重复的系统标识码",
    Invalid_Application: "无效的测试系统",
    Empty_Upgrade: "请选择要更新的文件",
    Invalid_Version: "无效的版本号",
    Invalid_Record: "无效的记录",
    NotFound_Record: "找不到数据记录",
    Failed_ResetPassword: "重置密码失败",
    Incomplete_Infomation: "输入信息不完整",
    Invalid_Binded: "无效的绑定记录",
    ParallelLimit_License: "超过最大绑定数量",
    Exsist_PermissionGroup: "权限组已存在",
    Invalid_PermissionDenied: "权限不足",
    Invalid_PermissionGroup: "无效的角色权限",
    Duplicate_Project: "重复的测试项目",
    Duplicate_SportProject: "运动项目名称不能重复",
    Invalid_SportProject: "无效的运动项目",
    Invalid_File: "文件不存在!",
    UploadFailed_NoFile: "没有需要上传的文件!",
    DownloadFailed_NoFile: "找不到文件!",
    Incorrect_Format: "数据格式不正确",
    UploadFailed_Timeout: "上传超时!",
    DownloadFailed_Timeout: "下载超时!",
    Repeat_Name: "已有同名用户",
    Empty_Account: "请输入账户",
    Empty_Password: "请输入密码",
    Empty_Name: "请输入姓名",
    Invationing_SubjectEmail: '该邮箱正在被邀请中',
    Invationing_SubjectName: '运动员名称正在被邀请中',
    Invalid_InvationLink: '链接已失效',
    Submit_SubjectInfo: '运动员已提交资料',
    Incorrect_Subject: '运动员不存在',
    Incomplete_InvationCode: '邀请码缺失',
    Duplicate_Subject: '运动员名称已存在',
    Duplicate_InvationEmail: '五分钟内不可对同一邮箱发送邀请',
    Invalid_RecordSide: '无效的顺序',
    NotBe_SameDay: "选择日期应为同一天",
    Invalid_Indicator: "无效的指标",
    Invalid_UserName: "用户昵称不可为空",
    UnUpload_SubjectOrProject: "未上传测试项或运动员",
    UnUpload_Subject: "未上传其中运动员",
    Duplicate_SubjectName: "受试人姓名重复",
    SyncData: "请先拉取数据",
    Duplicate_TrainingPlanName: "重复的训练计划名称",
    Invalid_TrainingPlan: "无效的训练计划",
    Invalid_Key: "无效的键值",
    Failed_CallService: "服务调用失败",
    FileNotExist: '文件不存在',
    Repeat_ProjectName: '项目名称重复'
}